/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 * Types for SettingsAutoReports table
 *
 * @author Anton Panasenko
 * @version 1.4.0
 * @since 1.3.0
 */

export enum ESettingsAutoReportsField {
    DESCRIPTION = 'description',
    ORDER_ATTR_TYPE = 'orderAttrType',
    PERIOD_TYPE = 'periodType',
    REMOVE = 'remove',
    REPORT_FORMAT = 'reportFormat',
    REPORT_NAME = 'report',
    START_TIME = 'startTime'
}

export interface ISettingsAutoReportsTableData {
    [ESettingsAutoReportsField.DESCRIPTION]: string;
    [ESettingsAutoReportsField.REPORT_NAME]: string;
    [ESettingsAutoReportsField.START_TIME]: number;
    [ESettingsAutoReportsField.REPORT_FORMAT]: string;
    [ESettingsAutoReportsField.PERIOD_TYPE]: string;
    [ESettingsAutoReportsField.ORDER_ATTR_TYPE]: string;
    dayOfPeriodName: string;
    cppoId: number;
    periodTypeName: string;
}

export const SettingsAutoReportsColumnNames: ESettingsAutoReportsField[] = [
    ESettingsAutoReportsField.REPORT_NAME,
    ESettingsAutoReportsField.PERIOD_TYPE,
    ESettingsAutoReportsField.START_TIME,
    ESettingsAutoReportsField.ORDER_ATTR_TYPE,
    ESettingsAutoReportsField.REPORT_FORMAT,
    ESettingsAutoReportsField.DESCRIPTION,
    ESettingsAutoReportsField.REMOVE,
];
